import { Link, Stack } from '@mui/material';

import { ExternalLink, Text, type api, isDefined } from 'common';

import { decodeUrlPath } from '../utils';

interface FlowTemplatePreviewCaseStudyProps {
  caseStudy?: api.FlowDefinitionTemplate.CaseStudy;
  imageTimestamp?: string;
  onRemoveImage?: () => Promise<void>;
}

export function FlowTemplatePreviewCaseStudy(props: FlowTemplatePreviewCaseStudyProps) {
  const { caseStudy, imageTimestamp, onRemoveImage } = props;

  if (!isDefined(caseStudy)) {
    return null;
  }

  return (
    <Stack gap={1}>
      <Stack direction="row" gap={3} alignItems="center">
        <img
          src={
            isDefined(imageTimestamp)
              ? `${decodeUrlPath(caseStudy.imageUrl)}?v=${imageTimestamp}`
              : decodeUrlPath(caseStudy.imageUrl)
          }
          alt="Case Study Image"
          width={250}
          style={{ objectFit: 'contain', borderRadius: 12 }}
        />
        <Stack gap={1} sx={{ maxWidth: 376 }}>
          <Text variant="heading4" bold>
            {caseStudy.title}
          </Text>
          <ExternalLink href={caseStudy.hyperlinkUrl}>
            <Text variant="body2">Read Case Study</Text>
          </ExternalLink>
        </Stack>
      </Stack>
      {isDefined(onRemoveImage) && (
        <Stack width={250} direction="row" justifyContent="center">
          <Link component="button" variant="body2" onClick={onRemoveImage}>
            Remove Image
          </Link>
        </Stack>
      )}
    </Stack>
  );
}
